<res-base-modal [modalTitle]="'Enter Security Code'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="securityCheck()"
    (closeButtonActionEmt)="closeModal()" [isPrimaryBtnEnabled]="true" [secondaryButtonLabel]="'Cancel'">

    <div class="security-code">
        <div class="modal-row no-padding">
            <div class="modal-row no-padding">
                <i class="fa fa-info fa-icon spacing"></i>
                <label class="info-text">A security code has been sent to the following email address: </label>
            </div>
            <div class="modal-row no-padding">
                <span>{{userEmail}}</span>
            </div>
        </div>
        <div class="modal-row right">
            <div class="modal-row-column-auto column-left-text">
                <label>Security Code: </label>
            </div>
            <div class="modal-row-column-auto">
                <input type="number" min="0" maxLength="6" oninput="this.value=this.value.slice(0,this.maxLength)"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                    name="securityCode" class="code-input"
                    (input)="clearErrors()" (focus)="clearErrors()" [(ngModel)]="securityCode"
                    data-automation-id="enter-security-code-security-code-input"
                    [(resScrollablePopover)]="popoverErrors.popover" [popoverErrorMessage]="popoverErrors.message"
                    [popoverType]="popoverErrors.type" popoverPlacement="right" [popoverOffsetTop]="-6"
                    [popoverOffsetLeft]="-4" [isSingleLine]="true"
                    popoverAutomationId="enter-security-code-security-code-error-label">
            </div>
            <div class="modal-row-column-auto">
                <label class="expire-time">
                    Codes expire after 10 minutes</label>
            </div>
        </div>
        <div class="modal-row right">
            <div class="modal-row-column-auto remember-device">
                <res-custom-checkbox name="rememberDevice" automationId="enter-security-code-remember-this-device"
                    [(ngModel)]="rememberDevice" content="Remember this device" (ngModelChange)="onRememberDeviceChanged()"></res-custom-checkbox>
            </div>
            <div class="modal-row-column-auto">
                <div class="info" data-automation-id="enter-security-code-remember-remember-this-device-info-icon"
                    title="Enabling this option will set a cookie on your computer to allow you to log in without a security code in the future.">
                    <i class="fa fa-info-circle fa-icon spacing"></i>
                </div>
            </div>
        </div>
        <div class="send-code">
            <div class=" modal-row code-row">
                <label>Didn't receive a code? </label>
            </div>
            <div class="modal-row code-row">
                <div class="modal-row-column-auto row-cell">
                    <button type="button" class="secondary-button" (click)="sendNewCode()"
                        data-automation-id="enter-security-code-send-new-code-button">
                        Send Another Code
                    </button>
                </div>
                <div class="modal-row-column-auto code-message row-cell" *ngIf="showResendCodeMessage">
                    <label>A new code has been sent. Please enter it above.</label>
                </div>
            </div>
        </div>

    </div>

</res-base-modal>